// @flow
import React from 'react'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { getLayer, getLayers } from 'catena/er2_map_userlayers/js/utils'
import Snackbar from '@material-ui/core/Snackbar'
import type { MapsourcesType } from 'catena/er2_map_userlayers/js/reducers/mapsources'
import type { ServicesType } from 'catena/er2_map_services/js/reducers/services'

type PropsType = {
    appendToLogger: Function,
    mapsources: MapsourcesType,
    runLamps: Function,
    services: ServicesType,
    theme: {},
    token: {
        value: string,
    }
}

type StateType = {
    helpActive: boolean,
    lampsLayer?: string,
    resultRendered: boolean,
}

// eslint-disable-next-line react/prefer-statelesFs-function
class Lamps extends React.Component<PropsType, StateType> {
    constructor(props) {
        super(props)
        this.state = {
            lampsLayer: '',
            resultRendered: true,
        }
    }

    execute = () => {
        const layer = getLayer(this.props.mapsources, this.state.lampsLayer)
        this.props.runLamps(layer)
    }

    renderButtons() {
        const theme = this.props.theme
        return (
            <React.Fragment>
                <Button
                    classes={{
                        root: theme.buttonSubmit,
                    }}
                    disabled={!this.state.lampsLayer || this.props.services.running}
                    onClick={this.execute}
                >
                    <span>Submit</span>
                </Button>
            </React.Fragment>
        )
    }

    renderTool() {
        const layers = getLayers(this.props.mapsources).filter(l => l.layer_type && l.layer_type.toLowerCase() === 'polygon')
        const theme = this.props.theme
        return (
            <div className={theme.controlGroup}>
                <FormControl
                    classes={{
                        root: theme.muiFormControl,
                    }}
                    fullWidth
                >
                    <InputLabel htmlFor={'lamps_layer'}>Field Layer</InputLabel>
                    <Select
                        inputProps={{
                            name: 'lamps_layer',
                            id: 'lamps_layer',
                        }}
                        onChange={(evt) => {
                            const layerId = evt.target.value
                            this.setState({ lampsLayer: layerId })
                        }}
                        value={this.state.lampsLayer}
                    >
                        {layers.filter(lyr => lyr.layer_type && lyr.layer_type.toLowerCase() !== 'raster').sort((a, b) => a.name.localeCompare(b.name)).map(layer => (
                            <MenuItem key={layer.id} value={layer.id}>{layer.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        )
    }

    renderNotifications() {
        const result = this.props.services.result
        if (result && result.results) {
            const layerName = result.results.layer
            const message = `Result saved to ${layerName}`
            return (
                <div>
                    <Snackbar
                        open={this.state.resultRendered === false}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({ resultRendered: true })
                        }}
                        message={<span id="message-id">{message}</span>}
                    />
                </div>
            )
        }
        return (null)
    }

    render() {
        const theme = this.props.theme
        return (
            <div className={theme.geoBarCtr}>
                <div className={theme.formGroup}>
                    <span className={theme.toolLabel}>LAMPS land use extraction</span>
                    <i
                        className={`${theme.helpIcon} ${this.state.helpActive ? theme.helpIconActive : ''} fa fa-question-circle`}
                        onClick={() => this.setState({ helpActive: !this.state.helpActive })}
                        role="button"
                        tabIndex={0}
                    />
                </div>
                {this.state.helpActive &&
                    <div className={theme.helpInlineCtr}>
                        <div className={theme.helpInline}>
                            <p>
                                Add LAMPS land use data to a polygon layer.
                            </p>
                        </div>
                    </div>
                }
                <div className={theme.toolCtr}>
                    {this.renderTool()}
                    {this.renderButtons()}
                </div>
                {this.renderNotifications(theme)}
            </div>
        )
    }
}

export default Lamps
